/**
 * Created by ShaunBetts on 14-May-16.
 */

import PortalError from 'module/error/PortalError';

const AuthorisationError = function (message, code) {
  this.data = new PortalError(message, code).data;
  this.data.type = 'Authorisation';
  this.data.typeLabel = 'Do not have Permission';
};

AuthorisationError.prototype = Object.create(PortalError.prototype);

export default AuthorisationError;